import React from 'react'
import Navbar from '../componenets/Navbar'
import bgImage from '../Images/Rectangle1.png'
import Avatar_3 from '../Images/Wm1.jpeg'
import Wb_1 from '../Images/wb1.jpeg'
import Filtration from '../Images/Filtration.jpeg'
import Fishing from '../Images/fishing.jpeg'
import Npdc from '../Images/npdc1.png'
import Agip from '../Images/agip-logo.png'
import Hydro from '../Images/hydroserve1.png'
import Nlng from '../Images/nlng.png'
import Shell from '../Images/shell.png'
import Total from '../Images/total.png'
import { Link } from 'react-router-dom'
import Footer from '../componenets/Footer'
import { FiArrowUpRight } from 'react-icons/fi'

const Services = () => {
  return (
    <div>
        <Navbar />


    <section
      className="about_who-we-are"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="about_who-we-are-content">
        <p className="about_tag">What We Do</p>
        <h1>Comprehensive Oilfield Solutions for Peak Performance</h1>
      </div>
    </section>

    <section className="border_bottom_div  wow animate__animated animate__fadeInUp" data-wow-delay="0.2s">
        <h2>We are guided by industry best practices and client satisfaction.</h2>
    </section>

    <section className="services_detail_text  wow animate__animated animate__fadeInUp" data-wow-delay="0.4s">
        <p>At WellClean Oil Field Services Limited, we deliver end-to-end well intervention, drilling support, and production optimization services built on safety, precision, and innovation.</p>
        <p>We support upstream oil & gas operations with reliable technical expertise, modern equipment, and a highly experienced workforce that understands the complexity of energy operations in Nigeria.</p>
    </section>


    <section className='about_our_mission_carrier'>
        <div className="about_our_mission_text wow animate__animated animate__fadeInUp" data-wow-delay="0.3s">
            <h2>Wellbore Cleaning</h2>
            <p>We offer comprehensive wellbore cleaning services designed to remove drilling debris, scale, sand, and other contaminants that hinder effective well performance.</p>
            
            <Link to="/wellbore_cleaning_service">
              <div className="contactBtn">
                <button className="contact-btn">
                    Learn More
                </button>
                <button className="contact-btn">
                  <FiArrowUpRight  size={24}/>
                </button>
            </div>
          </Link>

        </div>
        <div className="about_our_mission_imgs">
            <img src={Wb_1} alt="img" />
        </div>
    </section>

    <section className='about_our_vision'>
    <div className='about_our_vision_carrier'>
        <div className="about_our_mission_imgs wow animate__animated animate__fadeInUp" data-wow-delay="0.3s">
            <img src={Filtration} alt="img" />
        </div>
        <div className="about_our_mission_text wow animate__animated animate__fadeInUp" data-wow-delay="0.4s">
            <h2>Filtration</h2>
            <p>Our filtration solutions ensure clean and contaminant-free fluids across drilling, completion, and production phases.</p>
                    <Link to="/filtration">
                      <div className="contactBtn">
                        <button className="contact-btn">
                            Learn More
                        </button>
                        <button className="contact-btn">
                          <FiArrowUpRight  size={24}/>
                        </button>
                    </div>
                  </Link>            
        </div>
    </div>
    </section>
    
    <section className='about_our_mission_carrier'>
        <div className="about_our_mission_text wow animate__animated animate__fadeInUp" data-wow-delay="0.3s">
            <h2>Fishing</h2>
            <p>We provide professional fishing services to retrieve stuck, lost, or damaged equipment from wellbores, minimizing downtime and ensuring safe well restoration.</p>
                    <Link to="/fishing">
                      <div className="contactBtn">
                        <button className="contact-btn">
                            Learn More
                        </button>
                        <button className="contact-btn">
                          <FiArrowUpRight  size={24}/>
                        </button>
                    </div>
                  </Link>            
        </div>
        <div className="about_our_mission_imgs wow animate__animated animate__fadeInUp" data-wow-delay="0.4s">
            <img src={Fishing} alt="img" />
        </div>
    </section>

    <section className='about_our_visions'>
    <div className='about_our_vision_carrier'>
        <div className="about_our_mission_imgs wow animate__animated animate__fadeInUp" data-wow-delay="0.3s">
            <img src={Avatar_3} alt="img" />
        </div>
        <div className="about_our_mission_text wow animate__animated animate__fadeInUp" data-wow-delay="0.4s">
            <h2>Wellhead Maintenance</h2>
            <p>WellClean delivers comprehensive wellhead maintenance solutions to preserve equipment integrity, enhance reliability, and extend asset life.</p>
                    <Link to="/wellHead_maintenance">
                      <div className="contactBtn">
                        <button className="contact-btn">
                            Learn More
                        </button>
                        <button className="contact-btn">
                          <FiArrowUpRight  size={24}/>
                        </button>
                    </div>
                  </Link>            
        </div>
    </div>
    </section>    

    <section>
        
            <div className="top_company">
              <div className="the_text_carrier">
                <div className="orangeline wow animate__animated animate__fadeInUp" data-wow-delay="0.2s"></div><span>Trusted By Top Companies in the Field</span><div className="orangeline"></div>
              </div>
              <div className="company_logo wow animate__animated animate__fadeInUp" data-wow-delay="0.3s">
                <div className="imgcarrier">
                    <img src={Total} alt="Total" />
                    <img src={Shell} alt="Shell" />
                    <img src={Npdc} alt="Npdc" />
                    <img src={Nlng} alt="NLNG" />
                    <img src={Hydro} alt="Hydroserve" />
                    <img src={Agip} alt="Agip" />
                </div>
              </div>
            </div>
    </section>

    <Footer />

    </div>
  )
}

export default Services